module.exports = __webpack_public_path__ + "static/media/leftImg.86be8b1c.webp";